/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { AppStartPayload } from './AppStartPayload';
import {
    instanceOfAppStartPayload,
    AppStartPayloadFromJSON,
    AppStartPayloadFromJSONTyped,
    AppStartPayloadToJSON,
} from './AppStartPayload';
import type { AppStopPayload } from './AppStopPayload';
import {
    instanceOfAppStopPayload,
    AppStopPayloadFromJSON,
    AppStopPayloadFromJSONTyped,
    AppStopPayloadToJSON,
} from './AppStopPayload';
import type { CalibrationSavedPayload } from './CalibrationSavedPayload';
import {
    instanceOfCalibrationSavedPayload,
    CalibrationSavedPayloadFromJSON,
    CalibrationSavedPayloadFromJSONTyped,
    CalibrationSavedPayloadToJSON,
} from './CalibrationSavedPayload';
import type { CameraErrorPayload } from './CameraErrorPayload';
import {
    instanceOfCameraErrorPayload,
    CameraErrorPayloadFromJSON,
    CameraErrorPayloadFromJSONTyped,
    CameraErrorPayloadToJSON,
} from './CameraErrorPayload';
import type { CaptureCompletePayload } from './CaptureCompletePayload';
import {
    instanceOfCaptureCompletePayload,
    CaptureCompletePayloadFromJSON,
    CaptureCompletePayloadFromJSONTyped,
    CaptureCompletePayloadToJSON,
} from './CaptureCompletePayload';
import type { CaptureTriggeredPayload } from './CaptureTriggeredPayload';
import {
    instanceOfCaptureTriggeredPayload,
    CaptureTriggeredPayloadFromJSON,
    CaptureTriggeredPayloadFromJSONTyped,
    CaptureTriggeredPayloadToJSON,
} from './CaptureTriggeredPayload';
import type { ClockShiftPayload } from './ClockShiftPayload';
import {
    instanceOfClockShiftPayload,
    ClockShiftPayloadFromJSON,
    ClockShiftPayloadFromJSONTyped,
    ClockShiftPayloadToJSON,
} from './ClockShiftPayload';
import type { ConfigChangedPayload } from './ConfigChangedPayload';
import {
    instanceOfConfigChangedPayload,
    ConfigChangedPayloadFromJSON,
    ConfigChangedPayloadFromJSONTyped,
    ConfigChangedPayloadToJSON,
} from './ConfigChangedPayload';
import type { DataPushCompletePayload } from './DataPushCompletePayload';
import {
    instanceOfDataPushCompletePayload,
    DataPushCompletePayloadFromJSON,
    DataPushCompletePayloadFromJSONTyped,
    DataPushCompletePayloadToJSON,
} from './DataPushCompletePayload';
import type { ErrorStateClearedPayload } from './ErrorStateClearedPayload';
import {
    instanceOfErrorStateClearedPayload,
    ErrorStateClearedPayloadFromJSON,
    ErrorStateClearedPayloadFromJSONTyped,
    ErrorStateClearedPayloadToJSON,
} from './ErrorStateClearedPayload';
import type { ErrorStateEnteredPayload } from './ErrorStateEnteredPayload';
import {
    instanceOfErrorStateEnteredPayload,
    ErrorStateEnteredPayloadFromJSON,
    ErrorStateEnteredPayloadFromJSONTyped,
    ErrorStateEnteredPayloadToJSON,
} from './ErrorStateEnteredPayload';
import type { GpsFixPayload } from './GpsFixPayload';
import {
    instanceOfGpsFixPayload,
    GpsFixPayloadFromJSON,
    GpsFixPayloadFromJSONTyped,
    GpsFixPayloadToJSON,
} from './GpsFixPayload';
import type { ImuReadPayload } from './ImuReadPayload';
import {
    instanceOfImuReadPayload,
    ImuReadPayloadFromJSON,
    ImuReadPayloadFromJSONTyped,
    ImuReadPayloadToJSON,
} from './ImuReadPayload';
import type { ImuTapPayload } from './ImuTapPayload';
import {
    instanceOfImuTapPayload,
    ImuTapPayloadFromJSON,
    ImuTapPayloadFromJSONTyped,
    ImuTapPayloadToJSON,
} from './ImuTapPayload';
import type { ImuTapSequenceCompletePayload } from './ImuTapSequenceCompletePayload';
import {
    instanceOfImuTapSequenceCompletePayload,
    ImuTapSequenceCompletePayloadFromJSON,
    ImuTapSequenceCompletePayloadFromJSONTyped,
    ImuTapSequenceCompletePayloadToJSON,
} from './ImuTapSequenceCompletePayload';
import type { ManualCaptureLoggedPayload } from './ManualCaptureLoggedPayload';
import {
    instanceOfManualCaptureLoggedPayload,
    ManualCaptureLoggedPayloadFromJSON,
    ManualCaptureLoggedPayloadFromJSONTyped,
    ManualCaptureLoggedPayloadToJSON,
} from './ManualCaptureLoggedPayload';
import type { SessionIntentPayload } from './SessionIntentPayload';
import {
    instanceOfSessionIntentPayload,
    SessionIntentPayloadFromJSON,
    SessionIntentPayloadFromJSONTyped,
    SessionIntentPayloadToJSON,
} from './SessionIntentPayload';
import type { SignsSavedPayload } from './SignsSavedPayload';
import {
    instanceOfSignsSavedPayload,
    SignsSavedPayloadFromJSON,
    SignsSavedPayloadFromJSONTyped,
    SignsSavedPayloadToJSON,
} from './SignsSavedPayload';
import type { SysinfoPayload } from './SysinfoPayload';
import {
    instanceOfSysinfoPayload,
    SysinfoPayloadFromJSON,
    SysinfoPayloadFromJSONTyped,
    SysinfoPayloadToJSON,
} from './SysinfoPayload';
import type { TarePayload } from './TarePayload';
import {
    instanceOfTarePayload,
    TarePayloadFromJSON,
    TarePayloadFromJSONTyped,
    TarePayloadToJSON,
} from './TarePayload';
import type { UnknownPayload } from './UnknownPayload';
import {
    instanceOfUnknownPayload,
    UnknownPayloadFromJSON,
    UnknownPayloadFromJSONTyped,
    UnknownPayloadToJSON,
} from './UnknownPayload';
import type { WeightReadPayload } from './WeightReadPayload';
import {
    instanceOfWeightReadPayload,
    WeightReadPayloadFromJSON,
    WeightReadPayloadFromJSONTyped,
    WeightReadPayloadToJSON,
} from './WeightReadPayload';
import type { WifiClientChangePayload } from './WifiClientChangePayload';
import {
    instanceOfWifiClientChangePayload,
    WifiClientChangePayloadFromJSON,
    WifiClientChangePayloadFromJSONTyped,
    WifiClientChangePayloadToJSON,
} from './WifiClientChangePayload';
import type { WifiStatusChangePayload } from './WifiStatusChangePayload';
import {
    instanceOfWifiStatusChangePayload,
    WifiStatusChangePayloadFromJSON,
    WifiStatusChangePayloadFromJSONTyped,
    WifiStatusChangePayloadToJSON,
} from './WifiStatusChangePayload';

/**
 * @type Payload
 * 
 * @export
 */
export type Payload = { type: 'app_start' } & AppStartPayload | { type: 'app_stop' } & AppStopPayload | { type: 'calibration_saved' } & CalibrationSavedPayload | { type: 'camera_error' } & CameraErrorPayload | { type: 'capture_complete' } & CaptureCompletePayload | { type: 'capture_triggered' } & CaptureTriggeredPayload | { type: 'clock_shift' } & ClockShiftPayload | { type: 'config_changed' } & ConfigChangedPayload | { type: 'data_push_complete' } & DataPushCompletePayload | { type: 'error_state_cleared' } & ErrorStateClearedPayload | { type: 'error_state_entered' } & ErrorStateEnteredPayload | { type: 'gps_fix' } & GpsFixPayload | { type: 'imu_read' } & ImuReadPayload | { type: 'imu_tap' } & ImuTapPayload | { type: 'imu_tap_sequence_complete' } & ImuTapSequenceCompletePayload | { type: 'manual_capture_logged' } & ManualCaptureLoggedPayload | { type: 'session_intent' } & SessionIntentPayload | { type: 'signs_saved' } & SignsSavedPayload | { type: 'sysinfo' } & SysinfoPayload | { type: 'tare' } & TarePayload | { type: 'unknown' } & UnknownPayload | { type: 'weight_read' } & WeightReadPayload | { type: 'wifi_client_change' } & WifiClientChangePayload | { type: 'wifi_status_change' } & WifiStatusChangePayload;

export function PayloadFromJSON(json: any): Payload {
    return PayloadFromJSONTyped(json, false);
}

export function PayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): Payload {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'app_start':
            return Object.assign({}, AppStartPayloadFromJSONTyped(json, true), { type: 'app_start' } as const);
        case 'app_stop':
            return Object.assign({}, AppStopPayloadFromJSONTyped(json, true), { type: 'app_stop' } as const);
        case 'calibration_saved':
            return Object.assign({}, CalibrationSavedPayloadFromJSONTyped(json, true), { type: 'calibration_saved' } as const);
        case 'camera_error':
            return Object.assign({}, CameraErrorPayloadFromJSONTyped(json, true), { type: 'camera_error' } as const);
        case 'capture_complete':
            return Object.assign({}, CaptureCompletePayloadFromJSONTyped(json, true), { type: 'capture_complete' } as const);
        case 'capture_triggered':
            return Object.assign({}, CaptureTriggeredPayloadFromJSONTyped(json, true), { type: 'capture_triggered' } as const);
        case 'clock_shift':
            return Object.assign({}, ClockShiftPayloadFromJSONTyped(json, true), { type: 'clock_shift' } as const);
        case 'config_changed':
            return Object.assign({}, ConfigChangedPayloadFromJSONTyped(json, true), { type: 'config_changed' } as const);
        case 'data_push_complete':
            return Object.assign({}, DataPushCompletePayloadFromJSONTyped(json, true), { type: 'data_push_complete' } as const);
        case 'error_state_cleared':
            return Object.assign({}, ErrorStateClearedPayloadFromJSONTyped(json, true), { type: 'error_state_cleared' } as const);
        case 'error_state_entered':
            return Object.assign({}, ErrorStateEnteredPayloadFromJSONTyped(json, true), { type: 'error_state_entered' } as const);
        case 'gps_fix':
            return Object.assign({}, GpsFixPayloadFromJSONTyped(json, true), { type: 'gps_fix' } as const);
        case 'imu_read':
            return Object.assign({}, ImuReadPayloadFromJSONTyped(json, true), { type: 'imu_read' } as const);
        case 'imu_tap':
            return Object.assign({}, ImuTapPayloadFromJSONTyped(json, true), { type: 'imu_tap' } as const);
        case 'imu_tap_sequence_complete':
            return Object.assign({}, ImuTapSequenceCompletePayloadFromJSONTyped(json, true), { type: 'imu_tap_sequence_complete' } as const);
        case 'manual_capture_logged':
            return Object.assign({}, ManualCaptureLoggedPayloadFromJSONTyped(json, true), { type: 'manual_capture_logged' } as const);
        case 'session_intent':
            return Object.assign({}, SessionIntentPayloadFromJSONTyped(json, true), { type: 'session_intent' } as const);
        case 'signs_saved':
            return Object.assign({}, SignsSavedPayloadFromJSONTyped(json, true), { type: 'signs_saved' } as const);
        case 'sysinfo':
            return Object.assign({}, SysinfoPayloadFromJSONTyped(json, true), { type: 'sysinfo' } as const);
        case 'tare':
            return Object.assign({}, TarePayloadFromJSONTyped(json, true), { type: 'tare' } as const);
        case 'unknown':
            return Object.assign({}, UnknownPayloadFromJSONTyped(json, true), { type: 'unknown' } as const);
        case 'weight_read':
            return Object.assign({}, WeightReadPayloadFromJSONTyped(json, true), { type: 'weight_read' } as const);
        case 'wifi_client_change':
            return Object.assign({}, WifiClientChangePayloadFromJSONTyped(json, true), { type: 'wifi_client_change' } as const);
        case 'wifi_status_change':
            return Object.assign({}, WifiStatusChangePayloadFromJSONTyped(json, true), { type: 'wifi_status_change' } as const);
        default:
            return json;
    }
}

export function PayloadToJSON(json: any): any {
    return PayloadToJSONTyped(json, false);
}

export function PayloadToJSONTyped(value?: Payload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'app_start':
            return Object.assign({}, AppStartPayloadToJSON(value), { 'type': 'app_start' } as const);
        case 'app_stop':
            return Object.assign({}, AppStopPayloadToJSON(value), { 'type': 'app_stop' } as const);
        case 'calibration_saved':
            return Object.assign({}, CalibrationSavedPayloadToJSON(value), { 'type': 'calibration_saved' } as const);
        case 'camera_error':
            return Object.assign({}, CameraErrorPayloadToJSON(value), { 'type': 'camera_error' } as const);
        case 'capture_complete':
            return Object.assign({}, CaptureCompletePayloadToJSON(value), { 'type': 'capture_complete' } as const);
        case 'capture_triggered':
            return Object.assign({}, CaptureTriggeredPayloadToJSON(value), { 'type': 'capture_triggered' } as const);
        case 'clock_shift':
            return Object.assign({}, ClockShiftPayloadToJSON(value), { 'type': 'clock_shift' } as const);
        case 'config_changed':
            return Object.assign({}, ConfigChangedPayloadToJSON(value), { 'type': 'config_changed' } as const);
        case 'data_push_complete':
            return Object.assign({}, DataPushCompletePayloadToJSON(value), { 'type': 'data_push_complete' } as const);
        case 'error_state_cleared':
            return Object.assign({}, ErrorStateClearedPayloadToJSON(value), { 'type': 'error_state_cleared' } as const);
        case 'error_state_entered':
            return Object.assign({}, ErrorStateEnteredPayloadToJSON(value), { 'type': 'error_state_entered' } as const);
        case 'gps_fix':
            return Object.assign({}, GpsFixPayloadToJSON(value), { 'type': 'gps_fix' } as const);
        case 'imu_read':
            return Object.assign({}, ImuReadPayloadToJSON(value), { 'type': 'imu_read' } as const);
        case 'imu_tap':
            return Object.assign({}, ImuTapPayloadToJSON(value), { 'type': 'imu_tap' } as const);
        case 'imu_tap_sequence_complete':
            return Object.assign({}, ImuTapSequenceCompletePayloadToJSON(value), { 'type': 'imu_tap_sequence_complete' } as const);
        case 'manual_capture_logged':
            return Object.assign({}, ManualCaptureLoggedPayloadToJSON(value), { 'type': 'manual_capture_logged' } as const);
        case 'session_intent':
            return Object.assign({}, SessionIntentPayloadToJSON(value), { 'type': 'session_intent' } as const);
        case 'signs_saved':
            return Object.assign({}, SignsSavedPayloadToJSON(value), { 'type': 'signs_saved' } as const);
        case 'sysinfo':
            return Object.assign({}, SysinfoPayloadToJSON(value), { 'type': 'sysinfo' } as const);
        case 'tare':
            return Object.assign({}, TarePayloadToJSON(value), { 'type': 'tare' } as const);
        case 'unknown':
            return Object.assign({}, UnknownPayloadToJSON(value), { 'type': 'unknown' } as const);
        case 'weight_read':
            return Object.assign({}, WeightReadPayloadToJSON(value), { 'type': 'weight_read' } as const);
        case 'wifi_client_change':
            return Object.assign({}, WifiClientChangePayloadToJSON(value), { 'type': 'wifi_client_change' } as const);
        case 'wifi_status_change':
            return Object.assign({}, WifiStatusChangePayloadToJSON(value), { 'type': 'wifi_status_change' } as const);
        default:
            return value;
    }
}

